import axios from 'axios';

// Use environment variables to determine the API URL
const API_URL = process.env.NODE_ENV === 'production' 
  ? 'https://devboard-revamp.onrender.com' // Actual render.com backend URL
  : 'http://localhost:8000';

// Create an axios instance with the base URL
const api = axios.create({
  baseURL: API_URL,
});

export default api;
